import React, { useRef, useState } from 'react';
import styled from 'styled-components';

import { useMarketTickerQuery } from 'api/queries/tickersQueries';
import RouterLink from 'components/basic/Link/RouterLink';
import { useOutsideClick, useSelectorActiveChain } from 'components/hooks';
import {
  Chains,
  chainsMap,
} from 'reduxState/exchange/exchangeActiveChainUtils';
import { getDashboardUrl } from 'reduxState/markets/listed/listedMarketsUtils';
import { closeMarketsSidebar } from 'reduxState/markets/marketsSidebar';
import { staticDispatch, useSelector } from 'reduxState/store';

import { Logo } from './images/Logo';
// import { LogoMini } from './images/LogoMini';

const Wrap = styled.div`
  position: relative;
`;

const WrapMain = styled.div<{ $opened: boolean }>`
  display: flex;
  padding: 5px 0 2px 15px;
  border-right: 1px solid transparent;
  align-items: center;
  ${props => (props.$opened ? 'border-color: var(--gray);' : '')}

  .isMobileStyle & {
    position: relative;

    padding-right: 12px;
    padding-left: 12px;
    overflow: hidden;
    img {
      display: flex;
      align-items: center;
      height: 100%;
      object-fit: contain;
      align-self: center;
    }
  }
`;

const ChainName = styled.div`
  padding-left: 32px;
  text-transform: uppercase;
`;

function ChainLogo({
  onClick,
  logoLink,
  chainCode,
  displayChainName,
}: {
  onClick?: () => void;
  logoLink: string;
  chainCode: Chains;
  displayChainName?: boolean;
}) {
  // const isMobile = useSelector(state => state.screen.isMobile);
  return (
    <RouterLink
      to={logoLink}
      onClick={onClick ? onClick : () => staticDispatch(closeMarketsSidebar())}
    >
      {/* {isMobile ? <LogoMini /> : <Logo />} */}
      <Logo height={24} />
      {displayChainName && (
        <ChainName
          style={{
            color:
              chainCode === 'binanceChain' ? 'var(--yellow2)' : 'var(--blue2)',
          }}
        >
          {chainsMap[chainCode]?.title}
        </ChainName>
      )}
    </RouterLink>
  );
}

export default function HeaderChainLogo() {
  const isMobile = useSelector(state => state.screen.isMobile);
  const { activeChain } = useSelectorActiveChain();
  const currentMarket = useSelector(state => state.markets.currentMarket);
  const defaultMarket = useSelector(
    state => state.markets.listedMarkets.defaultMarket
  );
  const { data: currentMarketTicker } = useMarketTickerQuery({
    market: currentMarket.pair,
    websocketSubscribe: false,
  });
  const [opened, setOpened] = useState(false);
  // const [switching, setSwitching] = useState(false);
  const switching = false;
  const wrapperRef = useRef<HTMLDivElement>(null);

  useOutsideClick(wrapperRef, opened, () => {
    setOpened(false);
  });

  return (
    <Wrap ref={wrapperRef}>
      <WrapMain $opened={opened}>
        <ChainLogo
          chainCode={activeChain}
          onClick={
            isMobile ? () => !switching && setOpened(!opened) : undefined
          }
          logoLink={
            isMobile
              ? '#'
              : getDashboardUrl(
                  activeChain,
                  (currentMarketTicker === false
                    ? defaultMarket
                    : currentMarket.pair || defaultMarket) ||
                    chainsMap.katanaEVMChain?.fallbackDefaultMarket
                )
          }
        />
      </WrapMain>
    </Wrap>
  );
}
